module.exports = __webpack_public_path__ + "img/note_icon.66f6de09.png";